// Returns the first part of a postal code pattern (e.g. "1000-2000, 3000, 4000AA-4000ZZ") that matchPostalCode can't
// match against, or null when every part is valid. Uses the same format checks as server/utils/matchPostalCode.ts
export default (postalCodePattern: string): string | null => {
    const parts = (postalCodePattern || '').split(',').map((part) => part.trim()).filter((part) => part)

    const invalidPart = parts.find((part) => {
        const [rangeStart, rangeEnd, ...rest] = part.split('-').map((value) => value.replace(/\s/g, '').toUpperCase())

        if (rest.length || !/^[0-9]{4}([A-Z]{2})?$/.test(rangeStart)) {
            return true
        }

        if (rangeEnd === undefined) {
            return false
        }

        // The end can be just two letters, e.g. 1000AA-ZZ
        const fullRangeEnd = /^[A-Z]{2}$/.test(rangeEnd) ? `${rangeStart.substring(0, 4)}${rangeEnd}` : rangeEnd

        if (!/^[0-9]{4}([A-Z]{2})?$/.test(fullRangeEnd)) {
            return true
        }

        const startNumbers = rangeStart.substring(0, 4)
        const endNumbers = fullRangeEnd.substring(0, 4)

        if (startNumbers !== endNumbers) {
            return startNumbers > endNumbers
        }

        const startLetters = rangeStart.substring(4)
        const endLetters = fullRangeEnd.substring(4)

        return !!startLetters && !!endLetters && startLetters > endLetters
    })

    return invalidPart ?? null
}
